import { Partner } from '../../../services';

interface SelectItems {
  value?: string;
  title?: string;
  disabled?: boolean;
}

export default function usePartnerSelect(partners: Array<Partner>, notProvided: string) {
  return {
    items: partners
      .map((partner: Partner): SelectItems => ({ value: partner.id, title: partner.name }))
      .concat([
        { title: '-----', disabled: true },
        { value: 'not_in_list', title: notProvided },
      ]),
  };
}
